export default "__VITE_ASSET__CCPlZz2m__"